import React from 'react';
import { Toaster } from 'sileo';
import Layout from './components/layout/Layout';
import AppRoutes from './routes';

const App: React.FC = () => {
  return (
    <>
      <Toaster position="top-right" />
      <Layout>
        <AppRoutes />
      </Layout>
    </>
  );
};

export default App;
